export const TwitterLogo = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
  </svg>
);

export const GitHubLogo = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
  </svg>
);

export const ElixirLogo = (props: any) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="elixir" stroke="none" strokeWidth="1" fillRule="evenodd">
      <path
        d="M17.09765,1.5 C17.1497412,3.81765094 17.1152955,7.25457405 19.6828968,10.3853611 C22.2504981,13.5161481 25.497372,15.0920825 25.497372,19.9471981 C25.497372,26.2747555 20.7684736,29.5 16.6279496,29.5 C12.4874255,29.5 7.35194918,26.8152167 7.35194918,19.3300757 C7.35194918,15.1549422 9.36720832,9.90541524 13.054988,5.26198228 C14.2326866,3.77909413 15.6533698,2.19518803 17.09765,1.5 Z M11.3470908,26.4521125 C12.5331201,27.4321643 13.9984245,28.1077803 15.743004,28.4789605 C18.3598733,29.0357309 17.4057912,27.7081224 15.743004,27.1309646 C14.6344792,26.7461927 13.1691748,26.5199087 11.3470908,26.4521125 Z"
        id="Combined-Shape"
        fill="#fff"
      ></path>
    </g>
  </svg>
);

export const ReactLogo = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 -10.23174 23 20.46348" {...props}>
    <circle cx="0" cy="0" r="2.05" fill="#61dafb" />
    <g stroke="#61dafb" strokeWidth="1" fill="none">
      <ellipse rx="11" ry="4.2" />
      <ellipse rx="11" ry="4.2" transform="rotate(60)" />
      <ellipse rx="11" ry="4.2" transform="rotate(120)" />
    </g>
  </svg>
);

export const RustLogo = (props: any) => (
  <svg
    width="2500"
    height="2500"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <path d="M254.251 124.862l-10.747-6.653a145.81 145.81 0 0 0-.306-3.13l9.236-8.615a3.686 3.686 0 0 0 1.105-3.427 3.685 3.685 0 0 0-2.33-2.744l-11.807-4.415a137.355 137.355 0 0 0-.925-3.048l7.365-10.229a3.698 3.698 0 0 0-2.407-5.814l-12.45-2.025c-.484-.944-.988-1.874-1.496-2.796l5.231-11.483a3.683 3.683 0 0 0-.288-3.59 3.678 3.678 0 0 0-3.204-1.642l-12.636.44a99.848 99.848 0 0 0-1.996-2.421l2.904-12.308a3.694 3.694 0 0 0-.986-3.466 3.698 3.698 0 0 0-3.464-.986l-12.305 2.901a106.192 106.192 0 0 0-2.426-1.996l.442-12.635a3.684 3.684 0 0 0-1.64-3.205 3.693 3.693 0 0 0-3.59-.29l-11.48 5.234a133.235 133.235 0 0 0-2.796-1.5l-2.03-12.452a3.7 3.7 0 0 0-5.812-2.407l-10.236 7.365c-1.007-.32-2.02-.629-3.042-.922L155.72 4.794a3.69 3.69 0 0 0-2.745-2.336 3.707 3.707 0 0 0-3.424 1.106l-8.615 9.243a111.11 111.11 0 0 0-3.13-.306l-6.653-10.75a3.698 3.698 0 0 0-6.289 0l-6.653 10.75a110.4 110.4 0 0 0-3.133.306l-8.617-9.243a3.695 3.695 0 0 0-6.169 1.23l-4.414 11.809c-1.023.293-2.035.604-3.045.922L82.599 10.16a3.687 3.687 0 0 0-3.579-.415 3.705 3.705 0 0 0-2.235 2.822l-2.03 12.452c-.94.487-1.869.988-2.796 1.5l-11.481-5.235a3.686 3.686 0 0 0-3.588.291 3.684 3.684 0 0 0-1.642 3.205l.44 12.635a118.03 118.03 0 0 0-2.426 1.996l-12.305-2.9a3.71 3.71 0 0 0-3.466.985 3.694 3.694 0 0 0-.986 3.466l2.899 12.308c-.673.797-1.338 1.604-1.991 2.421l-12.636-.44a3.721 3.721 0 0 0-3.204 1.641 3.696 3.696 0 0 0-.291 3.59l5.234 11.484c-.509.922-1.012 1.852-1.5 2.796l-12.449 2.025a3.7 3.7 0 0 0-2.407 5.814l7.365 10.23c-.32 1.01-.631 2.024-.925 3.047l-11.808 4.415a3.702 3.702 0 0 0-1.225 6.171l9.237 8.614c-.115 1.04-.217 2.087-.305 3.131L1.75 124.862A3.695 3.695 0 0 0 0 128.007c0 1.284.663 2.473 1.751 3.143l10.748 6.653c.088 1.047.19 2.092.305 3.131l-9.238 8.617a3.697 3.697 0 0 0 1.226 6.169l11.808 4.415c.294 1.022.605 2.037.925 3.047l-7.365 10.231a3.696 3.696 0 0 0 2.41 5.812l12.447 2.025c.487.944.986 1.874 1.5 2.8l-5.235 11.48a3.691 3.691 0 0 0 .291 3.59 3.684 3.684 0 0 0 3.204 1.641l12.63-.442c.659.821 1.322 1.626 1.997 2.426l-2.899 12.31a3.682 3.682 0 0 0 .986 3.459 3.683 3.683 0 0 0 3.466.983l12.305-2.898c.8.68 1.61 1.34 2.427 1.99l-.44 12.639a3.694 3.694 0 0 0 5.229 3.492l11.481-5.231a105.49 105.49 0 0 0 2.796 1.499l2.03 12.445a3.692 3.692 0 0 0 2.235 2.825 3.706 3.706 0 0 0 3.579-.413l10.229-7.37c1.01.32 2.025.633 3.047.927l4.415 11.804a3.685 3.685 0 0 0 2.744 2.331 3.677 3.677 0 0 0 3.425-1.106l8.617-9.238c1.04.12 2.086.22 3.133.313l6.653 10.748a3.702 3.702 0 0 0 3.143 1.75 3.703 3.703 0 0 0 3.145-1.75l6.653-10.748c1.047-.093 2.092-.193 3.131-.313l8.615 9.238a3.68 3.68 0 0 0 3.424 1.106 3.69 3.69 0 0 0 2.744-2.331l4.415-11.804c1.022-.294 2.038-.607 3.048-.927l10.231 7.37a3.7 3.7 0 0 0 5.812-2.412l2.03-12.445c.939-.487 1.868-.993 2.795-1.5l11.481 5.232a3.692 3.692 0 0 0 5.23-3.492l-.44-12.638a98.76 98.76 0 0 0 2.423-1.991l12.306 2.898c1.25.294 2.56-.07 3.463-.983a3.682 3.682 0 0 0 .986-3.459l-2.898-12.31c.675-.8 1.34-1.605 1.99-2.426l12.636.442a3.681 3.681 0 0 0 3.204-1.64 3.685 3.685 0 0 0 .289-3.592l-5.232-11.478c.511-.927 1.013-1.857 1.497-2.8l12.45-2.026a3.682 3.682 0 0 0 2.822-2.236 3.696 3.696 0 0 0-.415-3.576l-7.365-10.23c.318-1.011.629-2.026.925-3.048l11.806-4.415a3.684 3.684 0 0 0 2.331-2.745 3.677 3.677 0 0 0-1.106-3.424l-9.235-8.617c.112-1.04.215-2.086.305-3.13l10.748-6.654a3.69 3.69 0 0 0 1.751-3.143c0-1.281-.66-2.472-1.749-3.145zm-71.932 89.156c-4.104-.885-6.714-4.93-5.833-9.047.878-4.112 4.92-6.729 9.023-5.844 4.104.879 6.718 4.931 5.838 9.04-.88 4.11-4.926 6.73-9.028 5.851zm-3.652-24.699a6.929 6.929 0 0 0-8.23 5.332l-3.816 17.807c-11.775 5.344-24.85 8.313-38.621 8.313-14.086 0-27.446-3.116-39.43-8.688l-3.814-17.806c-.802-3.747-4.486-6.134-8.228-5.33l-15.72 3.376a93.272 93.272 0 0 1-8.128-9.58h76.49c.865 0 1.442-.157 1.442-.945v-27.057c0-.787-.577-.944-1.443-.944H106.8v-17.15h24.195c2.208 0 11.809.63 14.878 12.902.962 3.774 3.072 16.05 4.516 19.98 1.438 4.408 7.293 13.213 13.533 13.213h38.115c.433 0 .895-.049 1.382-.137a93.92 93.92 0 0 1-8.669 10.17l-16.082-3.456zm-105.79 24.327c-4.105.886-8.146-1.731-9.029-5.843-.878-4.119 1.732-8.162 5.836-9.047 4.105-.878 8.148 1.739 9.028 5.85.878 4.11-1.734 8.16-5.836 9.04zM43.86 95.986c1.703 3.842-.03 8.345-3.867 10.045-3.837 1.705-8.328-.03-10.03-3.875-1.703-3.845.029-8.34 3.867-10.045a7.598 7.598 0 0 1 10.03 3.874zm-8.918 21.14l16.376-7.277a6.942 6.942 0 0 0 3.524-9.158l-3.372-7.626h13.264v59.788H37.973a93.7 93.7 0 0 1-3.566-25.672c0-3.398.183-6.756.535-10.056zm71.862-5.807V93.696h31.586c1.632 0 11.52 1.886 11.52 9.28 0 6.139-7.584 8.34-13.821 8.34h-29.285v.003zm114.792 15.862c0 2.338-.086 4.652-.257 6.948h-9.603c-.961 0-1.348.632-1.348 1.573v4.41c0 10.38-5.853 12.638-10.982 13.213-4.884.55-10.3-2.045-10.967-5.034-2.882-16.206-7.683-19.667-15.265-25.648 9.41-5.975 19.2-14.79 19.2-26.59 0-12.74-8.734-20.765-14.688-24.7-8.352-5.506-17.6-6.61-20.095-6.61H58.279c13.467-15.03 31.719-25.677 52.362-29.551l11.706 12.28a6.923 6.923 0 0 0 9.799.226l13.098-12.528c27.445 5.11 50.682 22.194 64.073 45.633l-8.967 20.253c-1.548 3.505.032 7.604 3.527 9.157l17.264 7.668c.298 3.065.455 6.161.455 9.3zM122.352 24.745c3.033-2.905 7.844-2.79 10.748.247 2.898 3.046 2.788 7.862-.252 10.765-3.033 2.906-7.844 2.793-10.748-.25a7.621 7.621 0 0 1 .252-10.762zm88.983 71.61a7.594 7.594 0 0 1 10.028-3.872c3.838 1.702 5.57 6.203 3.867 10.045a7.595 7.595 0 0 1-10.03 3.875c-3.833-1.703-5.565-6.2-3.865-10.048z" />
  </svg>
);

export const RabbitMQLogo = (props: any) => (
  <svg
    width="2362"
    height="2500"
    viewBox="0 0 256 271"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <path
      d="M245.44 108.308h-85.09a7.738 7.738 0 0 1-7.735-7.734v-88.68C152.615 5.327 147.29 0 140.726 0h-30.375c-6.568 0-11.89 5.327-11.89 11.894v88.143c0 4.573-3.697 8.29-8.27 8.31l-27.885.133c-4.612.025-8.359-3.717-8.35-8.325l.173-88.241C54.144 5.337 48.817 0 42.24 0H11.89C5.321 0 0 5.327 0 11.894V260.21c0 5.834 4.726 10.56 10.555 10.56H245.44c5.834 0 10.56-4.726 10.56-10.56V118.868c0-5.834-4.726-10.56-10.56-10.56zm-39.902 93.233c0 7.645-6.198 13.844-13.843 13.844H167.69c-7.646 0-13.844-6.199-13.844-13.844v-24.005c0-7.646 6.198-13.844 13.844-13.844h24.005c7.645 0 13.843 6.198 13.843 13.844v24.005z"
      fill="#fff"
    />
  </svg>
);

export const TypescriptLogo = (props: any) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="2500"
    height="2500"
    {...props}
  >
    <path fill="#007acc" d="M0 200V0h400v400H0" />
    <path
      fill="#fff"
      d="M87.7 200.7V217h52v148h36.9V217h52v-16c0-9 0-16.3-.4-16.5 0-.3-31.7-.4-70.2-.4l-70 .3v16.4l-.3-.1zM321.4 184c10.2 2.4 18 7 25 14.3 3.7 4 9.2 11 9.6 12.8 0 .6-17.3 12.3-27.8 18.8-.4.3-2-1.4-3.6-4-5.2-7.4-10.5-10.6-18.8-11.2-12-.8-20 5.5-20 16 0 3.2.6 5 1.8 7.6 2.7 5.5 7.7 8.8 23.2 15.6 28.6 12.3 41 20.4 48.5 32 8.5 13 10.4 33.4 4.7 48.7-6.4 16.7-22 28-44.3 31.7-7 1.2-23 1-30.5-.3-16-3-31.3-11-40.7-21.3-3.7-4-10.8-14.7-10.4-15.4l3.8-2.4 15-8.7 11.3-6.6 2.6 3.5c3.3 5.2 10.7 12.2 15 14.6 13 6.7 30.4 5.8 39-2 3.7-3.4 5.3-7 5.3-12 0-4.6-.7-6.7-3-10.2-3.2-4.4-9.6-8-27.6-16-20.7-8.8-29.5-14.4-37.7-23-4.7-5.2-9-13.3-11-20-1.5-5.8-2-20-.6-25.7 4.3-20 19.4-34 41-38 7-1.4 23.5-.8 30.4 1l-.2.2z"
    />
  </svg>
);

export const SolidityLogo = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="800"
    width="1200"
    viewBox="-78.58515 -203.242 681.0713 1219.452"
    {...props}
  >
    <path d="M391.93 0L261.226 232.302H0L130.614 0H391.93" opacity=".45" />
    <path d="M261.226 232.302h261.318L391.93 0H130.614z" opacity=".6" />
    <path d="M130.614 464.514l130.612-232.212L130.614 0 0 232.302z" opacity=".8" />
    <path d="M131.879 812.967l130.704-232.303h261.318L393.196 812.967H131.879" opacity=".45" />
    <path d="M262.582 580.665H1.265l130.613 232.303h261.317z" opacity=".6" />
    <path d="M393.196 348.453L262.582 580.665l130.614 232.303L523.9 580.665z" opacity=".8" />
  </svg>
);

export const KeyIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
  </svg>
);

export const ChevronDown = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

export const ChevronsRight = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="13 17 18 12 13 7"></polyline>
    <polyline points="6 17 11 12 6 7"></polyline>
  </svg>
);

export const ExternalLinkIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);

export const CompassIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
  </svg>
);

export const MenuIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

export const XIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const NavigationIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    {...props}
  >
    <polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>
  </svg>
);

export const SakurajimaLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 138.74 198.88">
    <g id="e4d740e9-a8b9-4619-9423-4e730640f47e" data-name="Layer 2">
      <g id="a1d15ffe-b1c6-44f7-972b-d2e7116ec5ad" data-name="Layer 1">
        <path
          d="M113.67,108.87c2.7-5.4,43.27-87.76,15.25-108.73,0,0-29.63-8-40.29,95a69.74,69.74,0,0,0-38.57.16l.06,0C39.47-7.84,9.82.14,9.82.14c-29,21.69,15.39,109,15.39,109l.06,0c-10.36,9.53-16.73,22.39-16.73,36.56,0,29.38,27.34,53.2,61.07,53.2s61.06-23.82,61.06-53.2C130.67,131.39,124.19,118.43,113.67,108.87Z"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
